import React from 'react';
import {MdOutlineBook, MdPerson, MdDateRange} from "react-icons/md";
import PropTypes from "prop-types";
import { Link } from 'lucide-react';

function MetaData({
                      inputContainerStyle,
                      inputStyle,
                      formData,
                      handleInputChange,
                      setIsFocused,
                      errors
                 
                  }) {

                    console.log("formData.authors", formData.authors)


    return (
        <>
        <div style={{display: 'flex', gap: '20px'}}>

            <div style={{flex: 1}}>
                <label htmlFor="title" className="label-style">
                title  <span style={{ color: errors.title ? 'red' : 'black' }}>*</span>
                </label>
                <div style={{
                    ...inputContainerStyle,
                    borderColor: errors.title ? 'red' : inputContainerStyle.borderColor
                }}>
                    <MdOutlineBook className="icon-style" style={{ color: errors.title ? 'red' : 'inherit' }} />
                    <input
                        type="text"
                        id="title"
                        name="title"
                        style={{ ...inputStyle, borderColor: errors.title ? 'red' : inputStyle.borderColor }}
                        value={formData.title}
                        onChange={handleInputChange}
                        onFocus={() => setIsFocused(true)}
                        placeholder={"Enter article title"}
                    />
                </div>
                {errors.title && <p className="error-text">{errors.title}</p>}
            </div>

              <div style={{flex: 1}}>
                <label htmlFor="doi" className="label-style">DOI</label>
                <div style={{...inputContainerStyle}}>
                    <Link className="icon-style"/>
                    <input
                        type="text"
                        id="doi"
                        name="doi"
                        style={{...inputStyle }}
                        value={formData.doi}
                        onChange={handleInputChange}
                        onFocus={() => setIsFocused(true)}
                        placeholder={"Enter article DOI"}
                    />
                </div>
            </div>
        </div>



            <div style={{display: 'flex', gap: '20px'}}>
                <div style={{flex: 1}}>
                    <label htmlFor="authors" className="label-style">Author</label>
                    <div style={inputContainerStyle}>
                        <MdPerson className="icon-style"/>
                        <input
                            type="text"
                            id="authors"
                            name="authors"
                            style={inputStyle}
                            value={formData.authors}
                            onChange={handleInputChange}
                            onFocus={() => setIsFocused(true)}
                            placeholder={"Enter authors name"}
                        />
                    </div>
                    {errors.authors && <p className="error-text">{errors.authors}</p>}
                </div>

                <div style={{flex: 1}}>
                    <label htmlFor="publicationDate" className="label-style">Publication Date</label>
                    <div style={inputContainerStyle}>
                        <MdDateRange className="icon-style" />
                        <input
                            type="text"
                            id="publicationDate"
                            name="publicationDate"
                            style={inputStyle}
                            value={formData.publicationDate}
                            onChange={handleInputChange}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}
                            placeholder={"Enter publication date"}
                        />
                    </div>
                    {errors.publicationDate && <p className="error-text">{errors.publicationDate}</p>}
                </div>
            </div>
        </>
    );
}

MetaData.propTypes = {

    inputContainerStyle: PropTypes.object,
    inputStyle: PropTypes.object,
    formData: PropTypes.object,
    handleInputChange: PropTypes.func,
    setIsFocused: PropTypes.func,
    errors: PropTypes.object,

}
export default MetaData;